import { z } from 'zod';

export const pageableRequestSchema = z.object({
  page: z.number(),
  size: z.number(),
  sort: z.array(z.string()).optional(),
});
